// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"00708cb5","830":"f589d696"}[chunkId] + ".chunk.js";
};